export default __webpack_public_path__ + "locales/cafeteria.ky.json";